<template>
    <div v-if="ready" :class="{ scrolled }">
        <notice-turn />
        <the-header />
        <div class="main" :class="routeName">
            <router-view />
        </div>
        <!-- v-footer -->
    </div>
</template>

<script>
import NoticeTurn from "@/components/NoticeTurn";
import TheHeader from "@/components/TheHeader";
import directusHelper from "@/helpers/directus";
import scroll from "@/mixins/scroll.mixin";
import { clearLoader, waitForIntroduction } from "@/utils/loader.util";

export default {
    name: "app",
    mixins: [scroll],
    components: { NoticeTurn, TheHeader },
    data() {
        return {
            scrolled: false,
            ready: false,
        };
    },
    async created() {
        try {
            await this.fetchData();
        } catch (e) {
            console.error(e);
        } finally {
            this.reveal();
        }
    },
    computed: {
        routeName() {
            const name = this.$route.params.slug || this.$route.name;
            return name ? name.toLowerCase() : "";
        },
    },
    methods: {
        async fetchData() {
            const result = await directusHelper.getData();
            this.$store.dispatch("setData", result);
        },
        async reveal() {
            await waitForIntroduction();
            this.ready = true;
            await clearLoader();
        },
        handleScroll() {
            this.scrolled = window.scrollY >= 10;
        },
    },
};
</script>

<style lang="sass">
@import ~include-media/dist/include-media
@import ~styles/base
@import ~styles/layout
@import ~styles/typography
</style>
